import type { SVGProps } from "react";
export interface LifeVestIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LifeVestIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LifeVestIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.375 16.5v-.375h-6.75v.375a1.125 1.125 0 0 1-2.25 0v-.375H3a1.125 1.125 0 0 1 0-2.25h3.375V13.5a1.125 1.125 0 1 1 2.25 0v.375h6.75V13.5a1.125 1.125 0 1 1 2.25 0v.375H21l.116.006A1.125 1.125 0 0 1 21 16.125h-3.375v.375a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M17.875 3.878 15.7 3.335l-2.575 6.868v10.672H18c1.035 0 1.875-.84 1.875-1.875v-7.848l-.013-.016a.3.3 0 0 0-.047-.04c-1.086-.778-1.94-2.086-1.94-4.096zM6.125 7c0 2.01-.854 3.318-1.94 4.097a.3.3 0 0 0-.047.04q-.009.008-.013.015V19c0 1.035.84 1.875 1.875 1.875h4.875V10.203L8.298 3.335l-2.173.543zm14 0c0 1.275.496 1.905 1.001 2.267l.192.152c.439.384.807.97.807 1.7v7.88A4.125 4.125 0 0 1 18 23.126H6A4.125 4.125 0 0 1 1.875 19v-7.881c0-.835.481-1.48.999-1.852l.188-.148c.433-.38.813-1.003.813-2.12V3.002c0-.517.351-.966.852-1.092l4-1 .209-.032c.483-.029.941.26 1.117.728L12 6.796l1.947-5.191.092-.19A1.125 1.125 0 0 1 15.273.91l4 1c.5.126.852.575.852 1.092z"
      />
    </svg>
  );
}
